<template>
  <div>
    <h1>Support</h1>
    <lm-swatches-block :space="43.75" backgroundColor="#f4f4f4">
      <lm-container>
        <h2>Athletics, Recreation & Wellness</h2>
        <lm-row :md-gutter="35">

          <lm-col :md-span="6" v-for="(item, i) in module1" :key="i">
            <lm-column style="margin-bottom: 35px;" :src="item.pic" :title="item.title"
              :description="item.intro"
              :links="item.articles"></lm-column>
          </lm-col>
        </lm-row>
      </lm-container>
    </lm-swatches-block>
    <poster-module :type="1"></poster-module>
  </div>
</template>

<script>
import { frontArticles4Memu, frontThrMenu } from '@/api/api';
import { methodsMixins } from '@/mixins/index';
import PosterModule from '../column/components/PosterModule';

export default {
  components: {
    PosterModule
  },
  mixins: [methodsMixins],
  data() {
    return {
      module1: []
    }
  },
  created() {
    const list1 = [],
    list2 = [],
    list3 = [],
    list4 = [];
    this.getArticles('y0lm76nzz2', 'y0lw428x1m', list1);
    this.getArticles('y0lm76nzz2', 'y0lw429fkk', list2);
    this.getArticles('y0lm76nzz2', 'y0lw429rck', list3);
    this.getArticles('y0lm76nzz2', 'y0lw42aczs', list4);
    this.module1 = [{
      title: 'For Freshers',
      pic: require('@/assets/temp/g1.png'),
      intro: 'Welcome home.',
      articles: list1
    }, {
      title: 'Student Handbook',
      pic: require('@/assets/temp/g2.png'),
      intro: 'The handbook contains important information regarding the history of the university.',
      articles: list2
    }, {
      title: 'Visa Application',
      pic: require('@/assets/temp/g3.png'),
      intro: 'Do I need to do anything for staying in China legally?',
      articles: list3
    }, {
      title: 'Contact Us',
      pic: require('@/assets/temp/g4.png'),
      intro: 'Please feel free to contact us.',
      articles: list4
    }];
  },
  methods: {
    getPageData() {
      // 
      frontArticles4Memu({
        memu1Id: 'y0lm76nzz2',
        memu2Id: 'y0lw428x1m',
        pageNumber: this.freshers.pageNumber ++,
        pageSize: this.freshers.pageSize
      }).then(res => {
        this.freshers.list = res.data.list;
      })
      // 
      frontArticles4Memu({
        memu1Id: 'y0lm76nzz2',
        memu2Id: 'y0lw429fkk',
        pageNumber: this.handbook.pageNumber ++,
        pageSize: this.handbook.pageSize
      }).then(res => {
        this.handbook.list = res.data.list;
      })
      // 
      frontArticles4Memu({
        memu1Id: 'y0lm76nzz2',
        memu2Id: 'y0lw429rck',
        pageNumber: this.application.pageNumber ++,
        pageSize: this.application.pageSize
      }).then(res => {
        this.application.list = res.data.list;
      })
      // 
      frontArticles4Memu({
        memu1Id: 'y0lm76nzz2',
        memu2Id: 'y0lw42aczs',
        pageNumber: this.contactUs.pageNumber ++,
        pageSize: this.contactUs.pageSize
      }).then(res => {
        this.contactUs.list = res.data.list;
      })
    }
  }
}
</script>